module.exports = __webpack_public_path__ + "static/img/i13.7800bf9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/i13.png
// module id = Sowd
// module chunks = 1 2